import React, { useState } from 'react';
import { Card, Row, Col, Input, Form, Select, TimePicker } from 'antd';
import PageContainer from '../../../../CSIComponents/PageContainer';
import { Moment } from 'moment';
import { HHmmFormat, TIME_UNITS, DEADLINE_TYPES } from '@constants/index';
const Option = Select.Option;

interface propsTypes {
  cancellationDetails:{
    policycode?:string | null,
    deadlinetype:string,
    timeunit?:string | null,
    noofunits?:string | null,
    cancelmethod?:string | null,
    cancelTime?: Moment,
  }
}
const FormItem = Form.Item;
const { DAY_OF_ARRIVAL, UNIT_TIME } = DEADLINE_TYPES
const DeadLineEdit = (props: propsTypes, parentRef: React.Ref<unknown> | undefined) => {
    const cancelMethod = ['Before Arrival', 'After Booking', 'After Confirmation', 'After Arrival', 'After Departure']
    const [deadLineType, setDeadLineType] = useState<string>(props?.cancellationDetails?.deadlinetype)
    const handleChange = (value: string)=>{
      setDeadLineType(value)
    }
    return (
        <PageContainer>
            <Card style={{ marginTop: -15 }} title={props?.cancellationDetails?.policycode}>
                <div style={{ padding: "0 20px" }}>
                    <Row gutter={24}>
                        <Col span={6} className="col-margin">
                            <FormItem name="deadlinetype" label="Deadline Type">
                                <Select 
                                  style={{ width: '100%' }}
                                  showSearch
                                  allowClear
                                  onChange={ handleChange }
                                  >
                                    <Option value='Day of Arrival Time'>Day of Arrival Time</Option>
                                    <Option value='Time Unit'>Time Unit</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        {deadLineType === UNIT_TIME && (
                            <>
                              <Col span={6} className="col-margin">
                                <FormItem name="timeunit" label="Time Unit" rules={[{ required: true, message: 'This field is required' }]}>
                                    <Select allowClear style={{ width: '100%' }}
                                    showSearch>
                                        {TIME_UNITS.map(item => <Option value={item}>{item}</Option>)}
                                    </Select>
                                </FormItem>
                            </Col>
                            <Col span={6} className="col-margin">
                                <FormItem name="noofunits" label="Number of Units" rules={[
                                    { required: true, message: 'This field is required' },
                                    { pattern: /^-?\d*?$/, message: 'This field should be a number.' }
                                ]}>
                                    <Input />
                                </FormItem>
                            </Col>
                            <Col span={6}></Col>
                            <Col span={6} className="col-margin">
                                <FormItem name="cancelmethod" label="Cancellation Method" rules={[{ required: true, message: 'This field is required' }]}>
                                    <Select allowClear style={{ width: '100%' }}
                                    showSearch>
                                        {cancelMethod.map(item => <Option value={item}>{item}</Option>)}
                                    </Select>
                                </FormItem>
                            </Col>
                          </>
                        )}
                        {deadLineType === DAY_OF_ARRIVAL && (
                          <Col span={6} className="col-margin">
                            <FormItem name="cancelTime" label="Cancel Time " rules={[
                                { required: true, message: 'This field is required' }
                            ]}>
                                <TimePicker format={HHmmFormat}/>
                            </FormItem>
                          </Col>   
                        )}
                    </Row>
                </div>
            </Card>
        </PageContainer>
    )
}

export default DeadLineEdit;

